import {
  ACTIVE_STORE,
  DELIVERY_STORES_LIST,
  GET_TAX_CARD,
  GET_TAX_CASH,
  SAVE_POS_FEE,
  SELECT_STORE,
  SELECT_STORE_ID,
  UPDATE_ONLINE_DEL_FEE
} from "../actions/storeTypes";

const initialState: any = {
  storeList: [] || "",
  pickupStoreList: [] || "",
  deliveryStoreList: [] || "",
  cityList: [],
  menuPickupStoreList: [] || "",
  menuDeliveryStoreList: [] || "",
  selectStoreId: null,
  storeSelected: null,
  pos_fee: 0,
  deliveryfee: 0,
  onlineDeliveryfee: 0,
  taxDataCash: [] || "",
  taxDataCard: [] || "",
  activeStore: null,
};

const storeReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case "STORE_LIST": {
      let delivery: any = [];
      let pickup: any = [];
      // for (let i = 0; i < action.payload.length; i++) {
      //   let del = 0;
      //   action.payload[i].channel_timing_id.filter((channel: any) => {
      //     if (channel.channel_id.sales_channel_id == 1) {
      //       delivery.push(action.payload[i])
      //     }
      //   });
      //   action.payload[i].channel_timing_id.filter((channel: any) => {
      //     if (channel.channel_id.sales_channel_id == 2) {
      //       pickup.push(action.payload[i])
      //     }
      //   });
      // }
      for (let i = 0; i < action.payload.length; i++) {
        action.payload[i].channel_timing_id.forEach((channel: any) => {
          if (channel.channel_id.sales_channel_id == 1) {
            if (
              action.payload[i].is_channel_timing &&
              channel.store_open_time &&
              channel.store_close_time
            ) {
                action.payload[i].store_open_time = channel.store_open_time;
                action.payload[i].store_close_time = channel.store_close_time;
            }
              delivery.push({ ...action.payload[i] });
          } else if (channel.channel_id.sales_channel_id == 2) {
            if (
              action.payload[i].is_channel_timing &&
              channel.store_open_time &&
              channel.store_close_time
            ) {
              action.payload[i].store_open_time = channel.store_open_time;
              action.payload[i].store_close_time = channel.store_close_time;
            }
              pickup.push({ ...action.payload[i] });
          }
        });
      }
      return {
        ...state,
        storeList: action.payload,
        pickupStoreList: pickup,
        deliveryStoreList: delivery,
      };
    }
    case "CITIES_WEB": {
      return {
        ...state,
        cityList: action.payload,
      };
    }
    case "PICKUP_STORES_LIST": {
      return {
        ...state,
        menuPickupStoreList: action.payload,
      };
    }
    case SELECT_STORE_ID:
      return {
        ...state,
        selectStoreId: action.selectStoreId
      };
    case SELECT_STORE:
      return {
        ...state,
        storeSelected: action.storeSelected,
      };
    case GET_TAX_CASH:
      return {
        ...state,
        taxDataCash: action.payload,
        deliveryfee: action.deliveryfee
      };
    case GET_TAX_CARD:
      return {
        ...state,
        taxDataCard: action.payload,
        deliveryfee: action.deliveryfee
      };
    case UPDATE_ONLINE_DEL_FEE:
      return {
        ...state,
        onlineDeliveryfee:action.deliveryfee
      }
    case SAVE_POS_FEE:
      return {
        ...state,
        pos_fee: action.payload
      }
    case DELIVERY_STORES_LIST:
      return {
        ...state,
        menuDeliveryStoreList: action.payload,
      };
    case ACTIVE_STORE:
      return {
        ...state,
        activeStore: action.payload,
      };
    default:
      return state;
  }
};

export default storeReducer;